import { PropertyTab } from "interfaces/properties";
import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";
import { FONT_FAMILY_BOLD } from "styles/typography";
import { propertyContentTabs } from "utils/properties";

interface Props {
	curentTab: PropertyTab;
	changeActiveTab: (tab: PropertyTab) => void;
}

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	border-bottom: 2px solid ${MAIN_THEME.BORDER_COLOR};

	@media (max-width: 768px) {
		width: 100%;
		gap: 6px;
	}
`;

const Divider = styled.div`
	display: none;
`;

const Tab = styled.button<{ isActive: boolean }>`
	font-size: 16px;
	font-family: ${FONT_FAMILY_BOLD};
	font-weight: 500;
	color: ${(props) =>
		props.isActive ? MAIN_THEME.SECONDARY : MAIN_THEME.TEXT_SECONDARY};
	background: transparent;
	outline: none;
	border: none;
	padding: 12px 4px;
	text-align: center;
	line-height: 20px;
	border-radius: 0;
	border-bottom: 2px solid transparent;
	transition: all 0.2s ease;
	cursor: pointer;
	white-space: nowrap;
	margin-bottom: -2px;
	${(props) =>
		props.isActive
			? `
		color: ${MAIN_THEME.SECONDARY};
		border-bottom-color: ${MAIN_THEME.SECONDARY};
	`
			: ''}

	&:hover {
		${(props) =>
			!props.isActive
				? `
			color: ${MAIN_THEME.TEXT_PRIMARY};
		`
				: ''}
	}

	@media (max-width: 768px) {
		padding: 10px 8px;
		font-size: 14px;
	}
`;

const PropertiesDetailsTabs = (props: Props): JSX.Element => {
	const { curentTab, changeActiveTab } = props;

	const renderTabs = () =>
		propertyContentTabs.map((tab: PropertyTab) => {
			const isActive = tab.value === curentTab.value;

			return (
				<Tab
					key={tab.value}
					onClick={() => changeActiveTab(tab)}
					isActive={isActive}
				>
					{tab.title}
				</Tab>
			);
		});

	return (
		<Container>
			{renderTabs()}
			<Divider />
		</Container>
	);
};

export default PropertiesDetailsTabs;
